import { c as _c } from "react/compiler-runtime";
import * as Accordion from "@radix-ui/react-accordion";
import { ChevronDown } from "lucide-react";
import type { Question } from "./questions";
interface FaqAccordionItemProps {
  question: Question;
}
export function FaqAccordionItem(t0) {
  const $ = _c(20);
  const {
    question
  } = t0;
  let t1;
  if ($[0] !== question.id) {
    t1 = question.id.toString();
    $[0] = question.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = String(question.id);
  let t3;
  if ($[2] !== t2) {
    t3 = t2.padStart(2, "0");
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <span className="text-base md:text-4xl font-alt font-bold text-primary-300 shrink-0 tabular-nums">{t3}</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== question.question) {
    t5 = <span className="text-base md:text-lg font-semibold text-primary-800 leading-snug">{question.question}</span>;
    $[6] = question.question;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className="flex gap-4 items-center min-w-0">{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ChevronDown className="w-5 h-5 text-primary-400 shrink-0 transition-transform duration-300 ease-[cubic-bezier(0.87,0,0.13,1)] group-data-[state=open]:rotate-180" aria-hidden={true} />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6) {
    t8 = <Accordion.Header><Accordion.Trigger className="group flex w-full gap-4 cursor-pointer items-center justify-between px-5 py-4 md:px-7 md:py-6 text-left transition-colors duration-200 hover:bg-primary-50 data-[state=open]:bg-primary-50">{t6}{t7}</Accordion.Trigger></Accordion.Header>;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== question.answer) {
    t9 = <Accordion.Content className="overflow-hidden data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp"><div className="px-5 md:px-7 pt-0 pb-5 text-base md:text-lg text-primary-700 leading-relaxed border-t border-primary-100"><div className="pt-4">{question.answer}</div></div></Accordion.Content>;
    $[14] = question.answer;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t1 || $[17] !== t8 || $[18] !== t9) {
    t10 = <Accordion.Item value={t1} className="rounded-2xl border border-primary-100 bg-white shadow-sm overflow-hidden transition-colors duration-200 data-[state=open]:border-primary-200">{t8}{t9}</Accordion.Item>;
    $[16] = t1;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}